import { render, staticRenderFns } from "./RelatedProductsSelectionCard.vue?vue&type=template&id=5b77c3d6&scoped=true&"
import script from "./RelatedProductsSelectionCard.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductsSelectionCard.vue?vue&type=style&index=0&id=5b77c3d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77c3d6",
  null
  
)

export default component.exports